import { Dynamic, useReference } from "../../controllers/conductor";
import RegisterController from "../../controllers/Register";
import { Button } from "../widgets/buttons";

import "../../styles/widgets/widgets.css";
import "../../styles/entry.css";
import { listRoleOptions } from "../../misc/account";
import { Dropdown } from "../widgets/input";
import { useEffect, useState } from "react";
import { LocationSelector, ProvinceSelector } from "../widgets/form";
import { LoadingAnimation } from "../widgets/loading";
import { getController } from "../../controllers/getter";

import bgvideo from "../../assets/videos/san_juanico.mp4";

export function Register() {


    const controller = getController(RegisterController);
    controller.initialize();

    const { ready, registered } = controller.notifiers;
    const status = controller.status;

    return (<div className="entry-page register">
        <div className="video-wrapper">
            <video autoPlay loop muted>
                <source src={bgvideo} type="video/mp4" />
            </video>
        </div>
        <div className="card-wrap">
            <Dynamic conductor={[ ready, registered ]} child={()=>
                status.registered ? 
                    <div className="registered-card">
                        <h2>Noted!</h2>
                        <span>Your account is now pending for confirmation. Please contact the administrator to complete your registration, and go back to Login Page when done.</span>
                        <Button className="secondary" onClick={() => controller.goToLogin()}>GO TO LOGIN</Button>
                    </div>
                : <div className="auth-card">{status.ready ? <RegisterForm controller={controller} /> : <center><LoadingAnimation /></center>}</div>
            } />
            </div>
        </div>);
}

function RegisterForm({ controller }) {

    const { error, registering } = controller.notifiers;
    const status = controller.status;

    let role = {};

    
    /** @param {SubmitEvent} event */
    const onSubmit = (event) => {
        event.preventDefault();

        const { 
            fullname: { value: fullname }, 
            username: { value: username }, 
            contact: { value: contact }, 
            email: { value: email }, 
            password: { value: password }, 
            password2: { value: confirmPassword } 
        } = event.target.elements;

        controller.register({ fullname, username, contact, email, password, confirmPassword, role });
    };
    return <div>
        <div className="logo" />
        <div className="pretitle">DEPARTMENT OF TOURISM REGION 8</div>
        <div className="title">TOURISM STATISTICS REPORTING SYSTEM</div>
        <hr />
        <div className="title2">CREATE NEW ACCOUNT</div>
        <Dynamic conductor={error} child={()=>status.error ? <div className="error-strip">{status.error}</div> : ""} />
        <form onSubmit={onSubmit}>
            <div className="row">
                <input className="input" autoComplete="off" placeholder="Full Name" name="fullname" />
                <input className="input" autoComplete="off" placeholder="Username (for log in)" name="username" />
            </div>
            <div className="row">
                <input className="input" autoComplete="off" placeholder="Contact Number" name="contact" />
                <input className="input" autoComplete="off" placeholder="Email Address" name="email" />
            </div>
            <div className="row">
                <input className="input" placeholder="Password" name="password" type="password" />
                <input className="input" placeholder="Confirm Password" name="password2" type="password" />
            </div>
            <RoleSelector collection={controller.collection} onUpdate={r => role = r} />

            
            <Dynamic conductor={registering} child={()=>
                <Button color="blue" inProgress={status.registering}>{ status.registering ? "CREATING..." : "CREATE NOW" }</Button>
            } />
        </form>
    </div>
}


function RoleSelector({ collection, onUpdate }) {
    const roleOptions = listRoleOptions(true);

    const [ currentLGU, setLGU ] = useState(Object.keys(collection.lgu)[0]);
    const [ currentProvince, setProvince ] = useState(Object.keys(collection.province)[0]);
    const [ currentRole, setCurrentRole ] = useState("lgu");
    

    useEffect(() => {
        const data = { label: currentRole };
        if(currentRole === "lgu") data.lgu = currentLGU;
        else if(currentRole === "province") data.province = currentProvince;
        
        onUpdate(data);
    });

    return <div className="row role-selector">
        <div><Dropdown className="roles-dropdown" options={roleOptions} onSelect={(role) => setCurrentRole(role)} defaultValue={currentRole} /></div>
        {currentRole === "lgu" ? 
            <div><LocationSelector values={{ lgu: currentLGU }} collection={collection} onChange={({lgu, province}) => { 
                // setCurrentRoleSpecific(lgu);
                setLGU(lgu);
                setProvince(province);
            }} /></div>
        : ""}
        {currentRole === "province" ?
            <div><ProvinceSelector province={currentProvince} collection={collection} onChange={(province) => {
                // setCurrentRoleSpecific(province);
                setProvince(province);
            }} /></div>
        : ""}
    </div>
}